import { Component, OnInit, Input } from '@angular/core';

import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import * as fromRootStore from 'src/app/_apps/root/store';
import { ISearchCategory } from 'src/app/_apps/root/root.constants';
import { SearchCategory } from './search-category';
import { Policy } from 'src/app/_apps/bckp/domain/models';
import { BckpPolicySearchResult } from 'src/app/_common/models/search-result';

@Component({
    selector: 'aa-bckp-policy-search-category',
    templateUrl: './search-category.component.html',
    styleUrls: [
        './search-category.component.scss'
    ],
    standalone: false
})
export class BckpPolicyCategoryComponent extends SearchCategory<Policy> implements OnInit
{
    @Input() category: ISearchCategory;
    public results: Observable<BckpPolicySearchResult[]> = of([]);

    constructor(private store: Store<IAuroraState>)
    {
        super();
    }

    ngOnInit ()
    {
        this.results = this.store
            .pipe(
                select(fromRootStore.getBckpPoliciesSearchResults)
            );
    }
}
